export const homeFr = {
    announcementsTitle: 'Annonces',
    newsTitle: 'Dernières nouvelles',
    welcomeTitle: 'Bienvenue sur le hub uRTime',
    welcomeContent:
        "Bienvenue sur le nouveau Hub uRTime ! N'hésitez pas à nous contacter pour toute remarque ou difficulté rencontrée sur customercare@urtime.net."
}
